// A single topic or user.
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import ContactBadges from './contact-badges.jsx';
import LetterTile from './letter-tile.jsx';
import UnreadBadge from './unread-badge.jsx';

import { Drafty } from '../tinode/tinode';

import { previewFormatter } from '../lib/formatters.js';
import { deliveryMarker } from '../lib/utils.js';
import { IconCheckmark, IconNoCheckmark, IconThreeDots, IconPin, IconDraft } from '../icons/svg/index.js';
import { profile } from '../stores/storages/ProfileStorage.js';
import { Topic } from '../tinode/topic'
import Helpers from '../lib/helpers.js';
import TimeHelpers from '../lib/time'
import { KEYPRESS_DELAY } from '../config.js';
import MessageContent from '../tinode/message-content.js';
import { NODE_SUBTYPE_MESSAGE, NODE_TYPE_MESSAGE } from '../tinode/constants.js';

const messages = defineMessages({
  cannot_message_yourself: {
    id: 'cannot_message_yourself',
    defaultMessage: 'You cannot send messages to yourself',
    description: 'You cannot send messages to yourself'
  },
  yesterday: {
    id: 'yesterday',
    defaultMessage: 'Yesterday',
    description: 'Yesterday'
  }
});

class Contact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showButtonChat: false,
      typingIndicator: false
    }

    this.getLastMessageTime = this.getLastMessageTime.bind(this);

    this.handleClick = this.handleClick.bind(this);
    this.handleContextClick = this.handleContextClick.bind(this);
    this.handleForwardMessage = this.handleForwardMessage.bind(this);
    this.handleOpenChat = this.handleOpenChat.bind(this);
    this.handleInfoReceipt = this.handleInfoReceipt.bind(this);
    this.getClassName = this.getClassName.bind(this);

    this.keyPressTimer = null;
  }

  componentDidMount() {
    const { isShowTyping, topic } = this.props;
    if (isShowTyping) {
      topic.onInfo = this.handleInfoReceipt
    }

  }

  getLastMessageTime() {
    if (TimeHelpers.isCurrentDate(this.props.lastMsgTime)) {
      return TimeHelpers.getHHmm24(this.props.lastMsgTime)
    } else if (TimeHelpers.isCurrentYear(this.props.lastMsgTime)) {
      if (TimeHelpers.isPreviouDate(this.props.lastMsgTime)) {
        const { formatMessage } = this.props.intl;
        return formatMessage(messages.yesterday)
      }
      return TimeHelpers.getDDMM(this.props.lastMsgTime);
    } else {
      try {
        if (this.props.lastMsgTime.getTime() === 0) {
          return ''
        }
        return TimeHelpers.getDDMMYYYY(this.props.lastMsgTime);
      } catch (e) {
        return ''
      }
    }
  }

  handleClick(e) {
    if (!this.props.showButtonForward) {
      e.preventDefault();
      e.stopPropagation();
      const { formatMessage } = this.props.intl;
      const isMe = Topic.getThreadId(this.props.item) === profile.username;
      if (isMe) {
        Helpers.showErrorToasts(formatMessage(messages.cannot_message_yourself))
        return;
      }

      if (this.props.onSelected) {
        // Index this.props.index is used by GroupManager.
        this.props.onSelected(this.props.item, this.props.index);
      }
    }

  }

  handleContextClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.showContextMenu({ topicName: this.props.item, y: e.pageY, x: e.pageX });
    console.log(this.props.tinode.getTopicByName(this.props.item))
  }

  handleForwardMessage(e) {
    // this.handleClick(e)
    e.preventDefault();
    e.stopPropagation();

    this.props.onSelected(this.props.item, this.props.index);

    this.setState({
      showButtonChat: true,
    })
  }

  handleOpenChat(e) {
    e.preventDefault();
    e.stopPropagation();

    this.props.handleTopicSelected(this.props.item)
  }

  renderForwardButton() {
    if (this.state.showButtonChat) {
      return (
        <button className='open-chat-btn' onClick={this.handleOpenChat} >
          <FormattedMessage id="open_chat"
            defaultMessage="Open chat" description="Shown when forward message" />
        </button>
      )
    }
    return (
      <button className='forward-btn' onClick={this.handleForwardMessage} >
        <FormattedMessage id="forward_btn"
          defaultMessage="Send" description="Shown when forward message" />
      </button>
    )
  }

  handleInfoReceipt(info) {
    window.logger('handleInfoReceipt', info);
    switch (info.what) {
      case 'kp': {
        clearTimeout(this.keyPressTimer);
        this.keyPressTimer = setTimeout(_ => this.setState({ typingIndicator: false }), KEYPRESS_DELAY + 1000);
        if (!this.state.typingIndicator) {
          this.setState({ typingIndicator: true });
        }
        break;
      }
      default:

    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.unread != this.props.unread && this.state.typingIndicator) {
      clearTimeout(this.keyPressTimer);
      this.setState({ typingIndicator: false });
    }
  }

  getClassName() {
    let cls = '';
    if (!this.props.showCheckmark && this.props.selected) {
      cls += ' selected';
    }

    if (this.props.unread > 0) {
      cls += ' unread-context'
    }

    if (this.props.focusTag && this.props.focusId === this.props.item) {
      cls += ' selected';
    }

    return cls
  }

  render() {
    let title = this.props.title;
    if (!title) {
      title = <i><FormattedMessage id="unnamed_topic" defaultMessage="Unnamed"
        description="Title shown when the topic has no name" /></i>;
    } else if (title.length > 30) {
      // FIXME: this is probably wrong for RTL languages.
      title = title.substring(0, 28) + '…';
    }
    const online = this.props.now ? 'online' : 'offline';
    const avatar = this.props.avatar ? this.props.avatar : true;
    const badges = this.props.badges ? this.props.badges.slice() : [];
    const icon_badges = [];
    if (this.props.isVerified) {
      icon_badges.push({ icon: 'verified', color: 'verified-color' });
    }
    if (this.props.isStaff) {
      icon_badges.push({ icon: 'staff', color: 'staff-color' });
    }
    if (this.props.isDangerous) {
      icon_badges.push({ icon: 'dangerous', color: 'danger-color' });
    }
    if (this.props.acs) {
      if (this.props.showMode) {
        badges.push({ name: this.props.acs.getMode(), key: 'mode' });
      }
      if (this.props.acs.isMuted()) {
        icon_badges.push({ icon: 'muted' });
      }
      if (!this.props.acs.isJoiner()) {
        icon_badges.push({ icon: 'banned' });
      }
    }

    const lastMsg = this.props.lastMsg

    // The this.props.preview contains alreay shortened Drafty or string.
    let preview;
    let icon = deliveryMarker(this.props.received);
    if (this.props.messageOld) {
      preview = this.props.messageOld;
      icon = <IconDraft />;
    } else if (typeof this.props.preview == 'string') {
      preview = this.props.preview;

      if (lastMsg) {
        const tags = Array.isArray(lastMsg.tags) ? lastMsg.tags : []
        preview = MessageContent.renderContent(this.props.tinode, preview, { tags, clickAction: false, tagAll: lastMsg.tagAll })
      }
    } else if (Drafty.isValid(this.props.preview)) {
      const context = { formatMessage: this.props.intl.formatMessage, previewIsResponse: this.props.previewIsResponse }
      const content = Drafty.format(this.props.preview, previewFormatter, context)

      try {
        if (Array.isArray(content) && content.length > 0 && typeof content[0][0] === 'string') {
          content[0][0] = MessageContent.renderContent(this.props.tinode, content[0][0], {})
        }
      } catch (err) {
        console.error(err)
      }

      preview = React.createElement(React.Fragment, null, content);
    } else if (this.props.preview) {
      preview =
        <><i className="material-icons gray">warning_amber</i> <i className="gray">
          <FormattedMessage id="invalid_content"
            defaultMessage="invalid content" description="Shown when the message is unreadable" /></i>
        </>;
    }


    let titleClass = 'contact-title' + (this.props.deleted ? ' deleted' : '');
    if (this.props.lastMsgTime && !TimeHelpers.isCurrentYear(this.props.lastMsgTime)) {
      titleClass += ' last_msg_time_long'
    }

    const lastMessageClass = 'contact-last-message-time' + (this.props.unread ? ' last-message-time-unread' : '');
    const lastMessageTime = this.getLastMessageTime()

    let sender = ''
    if (lastMsg) {
      const type = lastMsg.type
      if (type === NODE_TYPE_MESSAGE.GROUPCHAT) {
        const subtype = lastMsg.subtype
        if (subtype !== NODE_SUBTYPE_MESSAGE.NOTIFY && subtype !== NODE_SUBTYPE_MESSAGE.VOTE) {
          const from = lastMsg.from
          if (from) {
            const msisdn = Topic.getThreadId(from)
            if (msisdn === profile.username) {
              sender = ''
            } else {

              const fromTopic = this.props.tinode.getTopicByName(from)
              if (fromTopic) {
                sender = `${Topic.getTopicName(fromTopic)}:`
              } else {
                sender = `${msisdn}:`
              }
            }
          }
        }
      }

    }


    return (
      <li className={this.getClassName()} onClick={this.handleClick}>
        <div className="avatar-box">
          <LetterTile
            tinode={this.props.tinode}
            avatar={avatar}
            title={this.props.title}
            topic={this.props.item}
            deleted={this.props.deleted} />
          {this.props.deleted ? <i className="deleted material-icons">cancel</i> :
            // this.props.showOnline ? <span className={online} /> :
            //   (this.props.showCheckmark && this.props.selected) ?
            //     <i className="checkmark material-icons">check_circle</i> : 
            null}
        </div>
        <div className="text-box">
          <div className='contact-title-container'>
            <div className='title-name-container'>
              <span className={titleClass}>{title}</span>
              {this.props.isGroup ? <i className="material-icons as-badge">group</i> : null}
              {this.props.isChannel ? <img src="/img/channel.png" className="channel" alt="channel" /> : null}
              <ContactBadges badges={icon_badges} />
            </div>
            {
              this.props.showLastMsgTime && this.props.lastMsgTime &&
              <div className={lastMessageClass}>{lastMessageTime}</div>
            }

          </div>
          {this.props.showMode ?
            <span><ContactBadges badges={badges} /></span> :
            this.props.small ? null :
              <React.Fragment>
                {this.state.typingIndicator ?
                  <div class="typing typing-contact">
                    <FormattedMessage
                      id="typing"
                      defaultMessage={"typing"}
                    />
                    <span class="jumping-dots">
                      <span class="dot-1"></span>
                      <span class="dot-2"></span>
                      <span class="dot-3"></span>
                    </span>
                  </div>
                  :
                  <div className="contact-comment">
                    {!this.props.onlyShowComment ?
                      <React.Fragment>
                        {icon}<span>{sender} {preview || this.props.comment || '\u00A0'}</span>
                      </React.Fragment>
                      :
                      <span>{this.props.comment}</span>
                    }
                  </div>
                }
              </React.Fragment>
          }
        </div>
        {this.props.showContextMenu ?
          <span className="menuTrigger">
            <a href="#" onClick={this.handleContextClick}>
              <IconThreeDots />
            </a>
          </span> : null}
        {
          this.props.isShowPin && this.props.isPin && <span className="pinTrigger"><IconPin /></span>
        }
        {!this.props.deleted ? <div className="menuTrigger-unread">
          <UnreadBadge count={this.props.unread} />
        </div> : null}
        {this.props.showCheckmarkContact &&
          <div className="selected">
            {this.props.checkMarkContact ? <IconCheckmark /> : <IconNoCheckmark />}
          </div>
        }
        {this.props.showButtonForward && this.renderForwardButton()}
      </li>
    );
  }
};

export default injectIntl(Contact);
